(function (Drupal, once, Swiper) {
  'use strict';
  let modalSwiper = null;

  Drupal.behaviors.partnerModalBehavior = {
    attach: function (context, settings) {
      const MODAL_ID = 'partner-detail-modal';

      // Initialize modal close handlers
      once('partner-modal-init', `#${MODAL_ID}`, context).forEach(modal => {

        // Close button handler
        const closeBtn = modal.querySelector('.modal-close');
        if (closeBtn) {
          closeBtn.addEventListener('click', () => {
            this.closeModal(modal);
          });
        }

        // Click outside to close
        modal.addEventListener('click', (event) => {
          if (event.target === modal) {
            this.closeModal(modal);
          }
        });

        // ESC key to close
        modal.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            this.closeModal(modal);
          }
        });

        // Clean up content when modal closes
        modal.addEventListener('close', () => {
          if (modalSwiper) {
            modalSwiper.destroy();
            modalSwiper = null;
          }
          const content = modal.querySelector('.partner-modal__content');
          if (content) {
            content.innerHTML = '';
          }
          // Remove loading class if present
          modal.classList.remove('loading');
        });

        // Handle htmx events on the modal content div
        const modalContent = modal.querySelector('.partner-modal__content');
        if (modalContent) {
          // Listen for htmx events on the content div (the target)
          modalContent.addEventListener('htmx:beforeSwap', () => {
            modal.classList.add('loading');
          });

          modalContent.addEventListener('htmx:afterSwap', () => {
            modal.classList.remove('loading');
            // Ensure modal is shown after content loads
            if (!modal.open) {
              modal.showModal();
            }
            // Focus management - focus on first focusable element
            const focusable = modal.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
            if (focusable) {
              focusable.focus();
            }

            // Initialize Swiper slides
            const modalMedia = modal.querySelector('.swiper');

            if (modalMedia) {
              const prevEl = modal.querySelector('.swiper-button-prev');
              const nextEl = modal.querySelector('.swiper-button-next');
              const paginationEl = modal.querySelector('.swiper-pagination');

              modalSwiper = new Swiper(modalMedia, {
                slidesPerView: 1,
                navigation: {
                  nextEl,
                  prevEl
                },
                pagination: {
                  el: paginationEl,
                  clickable: true
                }
              });
              modalSwiper.init();
            }
          });

          modalContent.addEventListener('htmx:responseError', () => {
            modal.classList.remove('loading');
            modalContent.innerHTML = '<div class="error-message">Unable to load partner details. Please try again.</div>';
            if (!modal.open) {
              modal.showModal();
            }
          });
        }
      });
    },

    closeModal: function (modal) {
      if (modal && modal.open) {
        modal.close();
      }

      if (modalSwiper) {
        modalSwiper.destroy();
        modalSwiper = null;
      }
    }
  };
})(Drupal, once, window.Swiper);
